import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  withStyles,
  CircularProgress,
  Typography,
  Divider,
  AccordionSummary,
  AccordionDetails,
  AccordionActions,
  Accordion,
  Grid,
  Tooltip,
} from '@material-ui/core';
import Select from 'react-select';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getTags } from '@pingum/app-state-management/tag/actions';
import { getTagTypes } from '@pingum/app-state-management/tagType/actions';
import { getStatuses } from '@pingum/app-state-management/status/actions';
import {
  getDashboards,
  getDashboardSubscriptions,
} from '@pingum/app-state-management/dashboard/actions';
import User from '../../../widgets/User';
import UserEventSubscriptionPopover from '../../../widgets/UserEventSubscriptionPopover';
import {
  getDashboardSearchText,
  getStatuses as getStatusItems,
  getTags as getTagItems,
} from '../../UserSubscriptions/DashboardSubscriptionsCard';
import DisplayMessage from '../../../widgets/DisplayMessage';
import { getUser } from '../../../../utils/userHelper';

import styles from './styles';

export const getTenantUserOptions = (tenantUsers, subscriptions) => tenantUsers
  .filter((tenantUser) => subscriptions.filter((subscription) => subscription.auth0UserId === tenantUser.auth0UserId).length === 0)
  .map((tenantUser) => ({
    value: tenantUser.auth0UserId,
    label: tenantUser.userFullName,
  }));

export const buildDashboardItem
  = (
    classes,
    dashboard,
    statuses,
    tags,
    tagTypes,
  ) => (
    <Grid container spacing={4} key={dashboard.id}>
      <Grid item xs={8} sm={4} className={classes.dashboardGridItem}>
        <Typography variant="h4">
          {dashboard.name}
        </Typography>
        {
          (
            dashboard.dashboardData.searchText
              && dashboard.dashboardData.searchText.length > 0
          )
              && (
                <Typography variant="caption">
                  Search Term Filter: { getDashboardSearchText(dashboard.dashboardData.searchText) }
                </Typography>
              )
        }
      </Grid>
      <Grid item xs={8} sm={4} className={classes.dashboardGridItem}>
        {getStatusItems(classes, dashboard.dashboardData.statusIds, statuses, dashboard.id)}
      </Grid>
      <Grid item xs={8} sm={4} className={classes.dashboardGridItem}>
        {getTagItems(
          classes,
          dashboard.dashboardData.tagConditions,
          tags,
          tagTypes,
          dashboard.id,
        )}
      </Grid>
    </Grid>
  );

export class OrganizationDashboardSubscriptionsCardComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: null,
      subscriptionAnchorEl: null,
    };

    this.props.getDashboards();
    this.props.getStatuses();
    this.props.getTags();
    this.props.getTagTypes();
  }

  handleLoadSubscriptions = (dashboardId) => {
    this.setState((prevState) => ({
      expanded: prevState.expanded === dashboardId
        ? null
        : dashboardId,
    }
    ), () => {
      this.props.getDashboardSubscriptions(dashboardId);
    });
  }

  handleAddDashboarSubscription = (event) => {
    this.props.updateDashboardSubscriptions(event.value, { dashboards: { add: [this.state.expanded] } }, 'Successfully subscribed user to dashboard');
  }

  handleRemoveDashboarSubscription = (auth0UserId) => {
    this.props.updateDashboardSubscriptions(auth0UserId, { dashboards: { remove: [this.state.expanded] } }, 'Successfully removed user subscription to dashboard');
  }

  handleLoadUserSubscriptions = (event, auth0UserId, email) => {
    this.setState({ subscriptionAnchorEl: event.currentTarget });
    this.props.getUserSubscription(auth0UserId, email);
  }

  handleCloseSubscriptionPopover = () => {
    this.setState({ subscriptionAnchorEl: null });
  }

  render() {
    const {
      classes,
      isFetchingDashboards,
      dashboards,
      statuses,
      tags,
      tagTypes,
      dashboardSubscriptions,
      isFetchingDashboardSubscriptions,
      tenantUsers,
      userSubscription,
      isFetchingUserSubscription,
      eventTypes,
    } = this.props;
    return (
      <div className={classes.root}>
        {
            isFetchingDashboards
              ? <div style={{ textAlign: 'center' }}><CircularProgress size={80} /></div>
              : (
                <div>
                  <Typography variant="h3" className={classes.catagoryTitle} id="dashboards-organization-group-title" gutterBottom>
                    Shared Dashboards
                  </Typography>
                  {
                  dashboards.length === 0
                  && (
                    <DisplayMessage
                      id="no-organization-dashboards-text"
                      title="No Shared Dashboards"
                      subTitle="You can create one from the dashboard or from your dashboard settings page"
                      icon="info_outline"
                    />
                  )
                }
                  {
                  dashboards.map((dashboard) => (
                    <Accordion
                      key={dashboard.id}
                      expanded={this.state.expanded === dashboard.id}
                      onChange={() => this.handleLoadSubscriptions(dashboard.id)}
                    >
                      <AccordionSummary expandIcon={<Tooltip title="Click to load subscriptions"><ExpandMoreIcon /></Tooltip>}>
                        {buildDashboardItem(
                          classes,
                          dashboard,
                          statuses,
                          tags,
                          tagTypes,
                        )}
                      </AccordionSummary>
                      <AccordionDetails style={{ display: 'block' }}>
                        {isFetchingDashboardSubscriptions
                          ? <div style={{ textAlign: 'center' }}><CircularProgress size={80} /></div>
                          : dashboardSubscriptions.map((subscription) => {
                            const tenantUser = getUser(subscription, tenantUsers);
                            return (
                              <User
                                key={tenantUser.auth0UserId}
                                chip
                                user={tenantUser}
                                showDelete
                                onDelete={() => {
                                  this.handleRemoveDashboarSubscription(tenantUser.auth0UserId);
                                }}
                                onClick={(e) => {
                                  this.handleLoadUserSubscriptions(
                                    e,
                                    tenantUser.auth0UserId,
                                    tenantUser.email,
                                  );
                                }}
                              />
                            );
                          })}
                      </AccordionDetails>
                      <Divider />
                      <AccordionActions>
                        <div className={classes.tenantUserSelect}>
                          <Select
                            value={null}
                            placeholder="Select users to subscribe to dashboard"
                            onChange={this.handleAddDashboarSubscription}
                            options={getTenantUserOptions(tenantUsers, dashboardSubscriptions)}
                          />
                        </div>
                      </AccordionActions>
                    </Accordion>
                  ))
                }
                  <UserEventSubscriptionPopover
                    subscriptionAnchorEl={this.state.subscriptionAnchorEl}
                    onClose={this.handleCloseSubscriptionPopover}
                    userSubscription={userSubscription}
                    isFetchingUserSubscription={isFetchingUserSubscription}
                    eventTypes={eventTypes}
                  />
                </div>
              )
          }
      </div>
    );
  }
}

OrganizationDashboardSubscriptionsCardComponent.propTypes = {
  classes: PropTypes.object,
  getDashboards: PropTypes.func,
  isFetchingDashboards: PropTypes.bool,
  dashboards: PropTypes.array,
  statuses: PropTypes.array,
  tags: PropTypes.array,
  tagTypes: PropTypes.array,
  getTags: PropTypes.func,
  getTagTypes: PropTypes.func,
  getStatuses: PropTypes.func,
  getDashboardSubscriptions: PropTypes.func,
  dashboardSubscriptions: PropTypes.array,
  isFetchingDashboardSubscriptions: PropTypes.bool,
  tenantUsers: PropTypes.array,
  updateDashboardSubscriptions: PropTypes.func,
  getUserSubscription: PropTypes.func,
  userSubscription: PropTypes.object,
  isFetchingUserSubscription: PropTypes.bool,
  eventTypes: PropTypes.array,
};

OrganizationDashboardSubscriptionsCardComponent.defaultProps = {
  classes: {},
  getDashboards: () => {},
  isFetchingDashboards: true,
  dashboards: [],
  statuses: [],
  tags: [],
  tagTypes: [],
  getStatuses: () => {},
  getTags: () => {},
  getTagTypes: () => {},
  getDashboardSubscriptions: () => {},
  dashboardSubscriptions: [],
  isFetchingDashboardSubscriptions: false,
  tenantUsers: [],
  updateDashboardSubscriptions: () => {},
  getUserSubscription: () => {},
  userSubscription: { disableNotifications: false },
  isFetchingUserSubscription: true,
  eventTypes: [],
};

export const mapStateToProps = (state) => ({
  isFetchingDashboards: state.dashboard.isFetchingDashboards,
  dashboards: state.dashboard.dashboards.filter((d) => (d.id >= 0 && d.organizationExposed)),
  statuses: state.status.statuses,
  tags: state.tag.tags,
  tagTypes: state.tagType.tagTypes,
  dashboardSubscriptions: state.dashboard.dashboardSubscriptions,
  isFetchingDashboardSubscriptions: state.dashboard.isFetchingDashboardSubscriptions,
  tenantUsers: state.tenant.tenantUsers,
  userSubscription: state.userSubscription.userSubscription,
  isFetchingUserSubscription: state.userSubscription.isFetchingUserSubscription,
  eventTypes: state.eventType.eventTypes,
});

export const mapDispatchToProps = (dispatch) => ({
  getDashboards: () => dispatch(getDashboards()),
  getStatuses: () => dispatch(getStatuses(false)),
  getTags: () => dispatch(getTags(false, false)),
  getTagTypes: () => dispatch(getTagTypes(false, false)),
  getDashboardSubscriptions: (dashboardId) => dispatch(getDashboardSubscriptions(dashboardId)),
});

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrganizationDashboardSubscriptionsCardComponent));
